<template> 
    <div name="soldoc-app-qrcode" class="soldoc-app-qrcode">
        <div class="soldoc-app-qrcode-inner">
            <div class="soldoc-app-area">
                <div class="text-area">
                    <strong>새로운 고객은<br>솔닥이 모셔올게요</strong>
                    <p>솔닥 앱에 우리 병원을 무료로 노출하고 병원을 홍보해보세요<br>지역별, 증상별 병원 검색 기능으로<br>고객을 자연스럽게 유치할 수 있습니다</p>
                </div>
                <div class="img-area">
                    <img src="../../assets/partners_pc/img_app.gif" alt="솔닥 APP 병원 목록" />
                </div>
            </div>
            <div class="soldoc-qrcode-area">
                <div class="text-area">
                    <strong>한 번 만난 고객<br>두 번은 더 쉽게</strong>
                    <p>원내 비치한 QR 코드로 환자는 언제든<br>우리 병원 진료를 예약할 수 있어요<br>뿐만 아니라 재진 리마인드 알림과<br>진료 본 병원 우선 노출로 재진율을 높여보세요</p>
                </div>
                <div class="img-area">
                    <img src="../../assets/partners_pc/img_qrcode.gif" alt="솔닥 QR 코드" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "soldoc-app-qrcode",
    data: function() {
        return {};
    },
    computed: {},
    mounted: function() {        
        $(window).scroll(function() {
            var height = $(document).scrollTop();
            var innerTop = $(".soldoc-app-qrcode-inner").offset().top;
            var aniApp = $(".soldoc-app-qrcode .soldoc-app-area");
            var aniQrcode = $(".soldoc-app-qrcode .soldoc-qrcode-area");

            if (height <= 0) {
                $(aniApp).removeClass('item-show').addClass('item-hide');
                $(aniQrcode).removeClass('item-show').addClass('item-hide');
            } else if (height > innerTop - 500 && height < innerTop + 1000) {
                $(aniApp).removeClass('item-hide').addClass('item-show');
                $(aniQrcode).removeClass('item-hide').addClass('item-show');
            } else if (height > innerTop + 2000) {
                $(aniApp).removeClass('item-show').addClass('item-hide');
                $(aniQrcode).removeClass('item-show').addClass('item-hide');
            }
        });
    },
    methods: {},
};
</script>

<style scoped>
.soldoc-app-qrcode {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: flex-start;
    width: 100%;
    height: 1312px;
    background: #F3F4F7;
    overflow: hidden;
}
.soldoc-app-qrcode .soldoc-app-qrcode-inner {    
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 26px;
    width: 1240px;
    padding: 169px 20px 175px;
}
.soldoc-app-qrcode .soldoc-app-qrcode-inner > div {
    display: flex;
    justify-content: space-between;
    width: 1200px;
    height: 471px;
    border-radius: 20px;
    padding: 90px 97px 0 82px;
}
.soldoc-app-qrcode .soldoc-app-area {
    background: #FFF;
    visibility: hidden;
    opacity: 0;
}
.soldoc-app-qrcode .soldoc-qrcode-area {
    background: #1A1F27;
    visibility: hidden;
    opacity: 0;
}
.soldoc-app-qrcode .item-hide {
    visibility: hidden;
    opacity: 0;
}
.soldoc-app-qrcode .item-show {
    visibility: visible;
    opacity: 1;
    animation: fadeInUp1 2s;
}
.soldoc-app-qrcode .text-area strong {
    display: inline-block;
    margin-top: 10px;
    font-size: 38px;
    font-weight: 600;
    line-height: 48px;
    color: #1A1A1A;
}
.soldoc-app-qrcode .soldoc-qrcode-area .text-area strong {
    margin-top: 12px;
    color: #FFF;
}
.soldoc-app-qrcode .text-area p {
    margin-bottom: 0;
    margin-top: 47px;
    font-size: 18px;
    font-weight: 400;
    line-height: 28px;
    color: #1A1A1A;
}
.soldoc-app-qrcode .soldoc-qrcode-area .text-area p {
    color: #FFF;
}
.soldoc-app-qrcode .soldoc-app-area .img-area {
    width: 311px;
    height: 381px;
    overflow: hidden;
}
.soldoc-app-qrcode .soldoc-app-area .img-area img {
    width: 100%;
}
.soldoc-app-qrcode .soldoc-qrcode-area .img-area {
    position: relative;
    margin-top: 2px;
    width: 355px;
    height: 379px;
    overflow: hidden;

}
.soldoc-app-qrcode .soldoc-qrcode-area .img-area img {
    position: absolute;
    right: 0;
    bottom: 0;    
}
.soldoc-app-qrcode .soldoc-qrcode-area .img-area::before {
    content: '';
    position: absolute;
    bottom: -2px;
    right: 0;
    width: 273px;
    height: 379px;
    background: url(../../assets/partners_pc/img_qrcode.png) 0 0 no-repeat;
    background-size: 273px 379px;
}
@keyframes fadeInUp1 {
    0% {
        opacity: 0;
        transform: translate3d(0, 30%, 0);
    }
    to {
        opacity: 1;
        transform: translateZ(0);
    }
}
</style>



// WEBPACK FOOTER //
// src/components/pc_partners/SoldocAppQrcode.vue